import * as React from 'react';
import { useFela } from 'react-fela';

import { getIconClass } from '../utils/icon-class';
import { Box } from './generic/box/box';
import * as styles from './PageHeader.style';

import type { Theme } from '../types';

interface Props {
  title: string;
  description?: string | null;
  icon?: string | null;
}

// Title block for a section or topic page: the tag's own icon beside its name
// and description.
const PageHeader = ({ title, description = null, icon = null }: Props): React.ReactElement => {
  const { theme } = useFela<Theme>();

  return (
    <Box style={styles.header} className="kb-page-header">
      {!!icon && (
        <Box as="span" style={styles.icon(theme)} className="kb-page-header__icon">
          <i className={getIconClass(icon)} />
        </Box>
      )}
      <Box style={styles.body} className="kb-page-header__body">
        <Box as="h2" style={styles.title(theme)} className="kb-page-header__title">
          {title}
        </Box>
        {!!description && (
          <Box as="p" style={styles.description} className="kb-page-header__description">
            {description}
          </Box>
        )}
      </Box>
    </Box>
  );
};

export default PageHeader;
